<p style="font-size: 15px; opacity: 0.8">
    Review your configurations below, and navigate to a previous tab to make any adjustments. Click
    the Submit button when you’re ready to save all of your changes.
</p>

<div class="table-container-kpi" style="padding-top: 15px">
    <kendo-grid
        [loading]="loading"
        [data]="grid"
        [sortable]="sortable"
        [scrollable]="'scrollable'"
        [sort]="sort"
        (sortChange)="sortChange($event)"
        [height]="745"
        class="lg-kendo-grid"
        #kendoGrid="kendoGrid"
        [autoSize]="true"
    >
        <kendo-grid-column
            field="clientKPIDescription"
            title="Key Performance Indicator"
            [width]="300"
        >
        </kendo-grid-column>

        <kendo-grid-column field="target" title="Target" [width]="115">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span *ngIf="dataItem.isPercentage">{{ dataItem.target | number }}%</span>
                <span *ngIf="!dataItem.isPercentage">{{ dataItem.kpiFormat === 'currency' ?  (dataItem.target | currency: 'USD':'symbol':'1.0-0') : (dataItem.target | number) }}</span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="range1End"
            title="Poor"
            [width]="125"
            [headerStyle]="{ 'background-color': '#fddbdb' }"
            [style]="{ 'background-color': '#fddbdb' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span style="padding-right: 4px">
                    <span *ngIf="dataItem.bestScore == 'Highest'" title="Less Than">&le;</span>
                    <span *ngIf="dataItem.bestScore == 'Lowest'" title="Greater Than">&ge;</span>
                </span>
                <span *ngIf="dataItem.isPercentage">{{ dataItem.range1End | number }}%</span>
                <span *ngIf="!dataItem.isPercentage">{{ dataItem.kpiFormat === 'currency' ?  (dataItem.range1End | currency: 'USD':'symbol':'1.0-0') : (dataItem.range1End | number) }}</span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="range2Start"
            title="Fair"
            [width]="175"
            [headerStyle]="{ 'background-color': '#fff9e7' }"
            [style]="{ 'background-color': '#fff9e7' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span *ngIf="dataItem.isPercentage"
                    >{{ dataItem.range2Start | number }}% - {{ dataItem.range2End | number }}%</span
                >
                <span *ngIf="!dataItem.isPercentage"
                    >{{ dataItem.kpiFormat === 'currency' ?  (dataItem.range2Start | currency: 'USD':'symbol':'1.0-0') : (dataItem.range2Start | number)  }} 
                    - {{ dataItem.kpiFormat === 'currency' ?  (dataItem.range2End | currency: 'USD':'symbol':'1.0-0') : (dataItem.range2End | number)  }} </span
                >
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="range3Start"
            title="Good"
            [width]="180"
            [headerStyle]="{ 'background-color': '#e0f3f3' }"
            [style]="{ 'background-color': '#e0f3f3' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span *ngIf="dataItem.isPercentage">{{ dataItem.range3Start | number }}% - {{ dataItem.range3End | number }}%</span>
                <span *ngIf="!dataItem.isPercentage"
                    >{{ dataItem.kpiFormat === 'currency' ?  (dataItem.range3Start | currency: 'USD':'symbol':'1.0-0') : (dataItem.range3Start | number)  }} 
                    - {{ dataItem.kpiFormat === 'currency' ?  (dataItem.range3End | currency: 'USD':'symbol':'1.0-0') : (dataItem.range3End | number)  }} </span
                >
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="range4Start"
            title="Very Good"
            [width]="180"
            [headerStyle]="{ 'background-color': '#f7efff' }"
            [style]="{ 'background-color': '#f7efff' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span *ngIf="dataItem.isPercentage">{{ dataItem.range4Start | number }}% - {{ dataItem.range4End | number }}%</span>
                <span *ngIf="!dataItem.isPercentage"
                    >{{ dataItem.kpiFormat === 'currency' ?  (dataItem.range4Start | currency: 'USD':'symbol':'1.0-0') : (dataItem.range4Start | number)  }} 
                    - {{ dataItem.kpiFormat === 'currency' ?  (dataItem.range4End | currency: 'USD':'symbol':'1.0-0') : (dataItem.range4End | number)  }} </span
                >
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="range5Start"
            title="Excellent"
            [width]="125"
            [headerStyle]="{ 'background-color': '#f3f9ed' }"
            [style]="{ 'background-color': '#f3f9ed' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span style="padding-right: 4px">
                    <span *ngIf="dataItem.bestScore == 'Lowest'" title="Less Than">&le;</span>
                    <span *ngIf="dataItem.bestScore == 'Highest'" title="Greater Than">&ge;</span>
                </span>
                <span *ngIf="dataItem.isPercentage">{{ dataItem.range5Start | number }}%</span>
                <span *ngIf="!dataItem.isPercentage">{{ dataItem.kpiFormat === 'currency' ?  (dataItem.range5Start | currency: 'USD':'symbol':'1.0-0') : (dataItem.range5Start | number)  }}</span>
            </ng-template>
        </kendo-grid-column>

        <!-- <kendo-grid-column field="range5Start" title="" [width]="275">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex"> </ng-template>
        </kendo-grid-column> -->
    </kendo-grid>
</div>
